export default function auth({ next, store }) {
  //eslint-disable-next-line
  // console.log('auth middleware')

  if (getCookie('jwt') !== localStorage.getItem('token')) {
    //force logout
    store.dispatch('auth/doLogout')
    window.location.reload()
  }

  // check cookies and auth
  if (localStorage.getItem('token')) {
    return next()
  } else {
    return next({
      name: 'login'
    })
  }
}

function getCookie(name) {
  const cookies = document.cookie.split('; ')
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue)
    }
  }
  return null
}
